<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/partners'">Partners</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      <span class="fs-5 fw-bold mb-0">Add {{ isProspect() ? 'prospect' : 'partner' }}</span>
    </li>
  </ol>
</nav>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="row g-3">

        <div class="col-4">
          <label class="form-label">Status</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-person-check"></i></span>
            <select class="form-select" formControlName="companyStatus">
              @for (companyStatus of companyStatusList; track companyStatus) {
                <option [value]="companyStatus">{{ 'companyStatus.' + companyStatus | translate }}</option>
              }
            </select>
          </div>
        </div>

        <div class="col-4">
          <label class="form-label">Language</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-translate"></i></span>
            <app-dropdown-select [multiple]="true" formControlName="langs">
              @for (lang of languages; track lang) {
                <app-dropdown-select-option [value]="lang.isoCode">
                  <img [ngSrc]="langService.getLanguageFlag(lang)" [alt]="lang.name"
                    width="24" height="24" class="me-1 country-flag">{{ lang.name }}
                  </app-dropdown-select-option>
                }
              </app-dropdown-select>
            </div>
          </div>

          <div class="col-4">
            <div class="row">
              <div class="col">
                <label for="partner-picture" class="form-label">Partner Profile Picture</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-image"></i></span>
                  <input type="file" id="partner-picture" class="form-control" (change)="partnerPictureUpload($event)">
                </div>
              </div>

              @if (partner?.image) {
                <div class="col-auto">
                  <div class="profile-picture">
                    <img [ngSrc]="imageService.getImageUrl($safeNavigationMigration(partner?.image), 128, 128)" alt="" fill>
                  </div>
                </div>
              }
            </div>
          </div>

          <div class="col-4">
            <label class="form-label">Civility</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-person"></i></span>
              <select class="form-select" formControlName="civility">
                @for (civility of civilityList; track civility) {
                  <option [value]="civility">{{ 'civility.' + civility | translate }}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-4">
            <label class="form-label">First Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
              <input type="text" class="form-control" placeholder="First name" formControlName="firstname">
            </div>
          </div>
          <div class="col-4">
            <label class="form-label">Last Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-person-fill"></i></span>
              <input type="text" class="form-control" placeholder="Last name" formControlName="lastname">
            </div>
          </div>

          <div class="col-6">
            <label class="form-label">Company Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-building"></i></span>
              <input type="text" class="form-control" placeholder="Company name" formControlName="companyName">
            </div>
          </div>

          <div class="col-6">
            <label class="form-label">Country</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-globe"></i></span>
              <select class="form-select" formControlName="country">
                @for (country of countries; track country) {
                  <option [ngValue]="country.isoCode">{{ country.name }}</option>
                }
              </select>
            </div>
          </div>

          <div class="col-6">
            <label class="form-label">Phone Number</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-telephone"></i></span>
              <input type="tel" class="form-control" placeholder="Phone number" formControlName="phoneNumber">
            </div>
          </div>

          <div class="col-6">
            <label class="form-label">Email Address</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-envelope"></i></span>
              <input type="email" class="form-control" placeholder="Email address" formControlName="email" autocomplete="new-password">
            </div>
          </div>

          <div class="col-6">
            <label class="form-label">Telegram</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-telegram"></i></span>
              <input type="text" class="form-control" placeholder="Telegram username" formControlName="telegram">
            </div>
          </div>
          <div class="col-6">
            <label class="form-label">Teams</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-microsoft-teams"></i></span>
              <input type="text" class="form-control" placeholder="Teams username" formControlName="teams">
            </div>
          </div>

          <div class="col-6">
            <label class="form-label">Prospect Origin</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
              <select class="form-select" formControlName="prospectOrigin">
                @for (prospectOrigin of prospectOriginList; track prospectOrigin) {
                  <option [value]="prospectOrigin">{{ 'prospectOrigin.' + prospectOrigin | translate }}</option>
                }
              </select>
            </div>
          </div>

          <div class="col-6">
            <label class="form-label">{{ isProspect() ? 'Prospect ' : '' }}Account Type</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-people"></i></span>
              <select class="form-select" id="accountType" formControlName="accountType">
                @for (accountType of partnerAccountTypeList; track accountType) {
                  <option [value]="accountType">{{ 'partnerAccountType.' + accountType | translate }}</option>
                }
              </select>
            </div>
          </div>

          @if (isMediaBuy()) {
            <div class="col-6">
              <label class="form-label">Advertising Platform</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-bar-chart-line"></i></span>
                <select class="form-select" formControlName="advertisingPlatform">
                  @for (advertisingPlatform of advertisingPlatformList; track advertisingPlatform) {
                    <option
                    [value]="advertisingPlatform.id">{{ advertisingPlatform.name }}</option>
                  }
                </select>
              </div>
            </div>
          }

          <div class="col-6">
            <label class="form-label">Account Manager</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-people"></i></span>
              <select class="form-select" formControlName="accountManagerId">
                @for (user of users; track user) {
                  <option [value]="user.id">{{ user }}</option>
                }
              </select>
            </div>
          </div>

          <div class="col-6">
            <label class="form-label">Status</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-people"></i></span>
              <select class="form-select" formControlName="status">
                @for (partnerStatus of partnerStatusList; track partnerStatus) {
                  <option [value]="partnerStatus">{{ 'partnerStatus.' + partnerStatus | translate }}</option>
                }
              </select>
            </div>
          </div>

          <div class="text-end">
            <button type="submit" class="btn btn-primary fw-bold">
              <span>Create</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
